<template >
	<span class="input">
		<input class="text-box single-line" id="EMail" name="EMail" type="text" v-model="model.eMail" :placeholder="bestaetigt+'*'" required>
	</span>	
</template>

<script lang="ts">
import {defineComponent} from "vue";

const EmailEditor = defineComponent({
    name: "EmailEditor",
    data() {
        return {
			bestaetigt: ""
    	}
	},
    props:{
		model: {}
    },
    async mounted(){
		this.bestaetigt = "E-Mail (" + (this.model.eMailBestaetigt ? "" : (this.model.eMailInitialBestaetigt ? "nicht mehr " : "noch nie ")) + "bestätigt)";
    },
    methods:{
      
    }
});
export default EmailEditor;
</script>

